import Script from 'next/script';
import { publicEnvConfig } from 'helpers/env';

/**
 * Ortto tracking snippet component
 * This loads the Ortto tracking code required for push notifications and user tracking
 * @param {boolean} isLoggedIn - Whether to enable capture widgets for logged-in users
 */
const OrttoSnippet = ({ isLoggedIn = false }) => {
	return (
		<>
			{/* Ortto tracking script */}
			<Script
				id="ortto-tracking"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
						window.ap3c = window.ap3c || {};
						var ap3c = window.ap3c;
						ap3c.cmd = ap3c.cmd || [];
						ap3c.cmd.push(function() {
							ap3c.init('${publicEnvConfig.NEXT_PUBLIC_ORTTO_TRACKING_ID}', '${publicEnvConfig.NEXT_PUBLIC_ORTTO_CAPTURE_API_URL}', {
								disableWidgets: ${!isLoggedIn}
							});
							ap3c.track({v: 0});
						});
						ap3c.activity = function(act) { ap3c.act = (ap3c.act || []); ap3c.act.push(act); };
						var s, t; s = document.createElement('script'); s.type = 'text/javascript'; s.src = "https://cdn3l.ink/app.js";
						t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
					`,
				}}
			/>
		</>
	);
};

export default OrttoSnippet;
